module.exports = __webpack_public_path__ + "img/Liqlid_icon_logo.34114c5b.png";